import { Dialog } from '@angular/cdk/dialog'
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'

import { Badge } from '@features/sala-de-trofeos/models'
import { Image } from '@shared/components'
import { BadgeDetailsModal } from '../badge-details-modal/badge-details-modal'

@Component({
  selector: 'badge-card',
  imports: [Image],
  templateUrl: './badge-card.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BadgeCard {
  #dialog = inject(Dialog)

  badge = input.required<Badge>()

  openModal() {
    this.#dialog.open(BadgeDetailsModal, {
      data: { badge: this.badge() }
    })
  }
}
